import React, { CSSProperties } from 'react';
import ButtonSymphony, { ButtonVariant } from './ButtonSymphony';
import useScreen from 'Hooks/useScreen';

interface ViewButtonProps {
    onClick: () => void;
    className?: string;
    style?: CSSProperties;
    variant?: ButtonVariant;
    size?: 'small' | 'medium' | 'large';
    fullWidth?: boolean;
}

const ViewButton: React.FC<ViewButtonProps> = ({ 
    onClick,
    className = 'viewButton',
    style,
    variant,
    size,
    fullWidth = false
}) => {
    const { mediumView } = useScreen();

    // Use responsive defaults if not specified
    const buttonVariant = variant || (mediumView ? 'outlined' : 'text');
    const buttonSize = size || (mediumView ? 'small' : 'medium');
    const width = fullWidth ? '100%' : 'fit-content';

    return (
        <ButtonSymphony
            className={className}
            style={{
                width: fullWidth ? '100%' : undefined,
                ...style
            }}
            variant={buttonVariant}
            onClick={onClick}
            iconRight={mediumView ? undefined : 'chevronRight'}
            width={width}
            iconRightOffset={-8}
            iconRightSize={18}
            size={buttonSize}
        >
            View
        </ButtonSymphony>
    );
};

export default ViewButton; 